import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { PhaseType } from '@schema/phase'
import { creationGuideDisplay, InitiativeCreationStep, initiativeCreationSteps } from './workflow'
import { ReactNode } from 'react'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { Text } from '@app/components/core/typography/Text'

export const CreationGuide = ({
  selectedPhaseType,
  currentStep,
  children,
  isEditing,
}: {
  selectedPhaseType: PhaseType | null
  currentStep: InitiativeCreationStep
  children: ReactNode
  isEditing?: boolean
}) => {
  const steps = creationGuideDisplay(selectedPhaseType, currentStep)
  return (
    <Column
      alignItems="stretch"
      style={{
        justifyContent: 'center',
        paddingInline: '5rem',
        '@media (max-width: 1400px)': {
          paddingInline: 0,
        },
      }}
    >
      <Row
        gap="5rem"
        alignItems="center"
        style={{ justifyContent: 'space-between' }}
      >
        <CreationGuideAssignment
          steps={steps}
          activeStep={currentStep}
          isEditing={isEditing}
        />
        <Column
          alignItems="stretch"
          style={{ flex: '1 0 30rem', maxWidth: '30rem' }}
        >
          {children}
        </Column>
      </Row>
    </Column>
  )
}

const CreationGuideAssignment = ({
  steps,
  activeStep,
  isEditing,
}: {
  steps: InitiativeCreationStep[]
  activeStep: InitiativeCreationStep
  isEditing?: boolean
}) => {
  const translations = useTranslations().app.dashboard.initiative.creation
  const hasStepNumbers = steps.length > 1
  const active = steps.length === 1 ? steps[0] : activeStep
  return (
    <Column gap="2rem" style={{ flex: '1 0 30rem', maxWidth: '30rem' }}>
      {steps.map((step, index) => {
        const isActive = step === active
        const isEditCallSchedule =
          isEditing && step === initiativeCreationSteps.callSchedule

        //TODO: Remove this edit special state when initiative form editing is implemented
        const title = isEditCallSchedule
          ? translations.callScheduleEditTitle
          : translations.creationStepTitles[step]
        const description = isEditCallSchedule
          ? translations.callScheduleEditDescription
          : translations.creationStepDescriptions[step]

        return (
          <span key={index}>
            <Title.Hx
              title={isActive ? 'H2' : 'H4'}
              style={{
                color: isActive ? 'var(--primary-blue)' : 'var(--gray-300)',
              }}
            >
              {(hasStepNumbers ? `${index + 1}. ` : '') + title}
            </Title.Hx>
            {description && <Text.Medium>{description}</Text.Medium>}
          </span>
        )
      })}
    </Column>
  )
}
